<template>
    <div class="global-content">
        <div class="question clearfix">
            <div class="question-left">
                <ul>
                    <li
                        :class="{ active: showLeftIndex == item.moduleId }"
                        v-for="(item, index) in questionTab"
                        :key="index"
                    >
                        <i :class="[{ iconfont: true }, item.img]"></i>
                        <!-- <img :src="require('../../../static/imgApp/'+item.img+'-g.png')"> -->
                        {{ item.moduleName }}
                        <span v-show="showLeftIndex == item.moduleId"></span>
                    </li>
                </ul>
            </div>
            <div class="question-right">
                <div
                    :class="{ active: showRightIndex === index }"
                    class="right-box"
                    v-for="(item, index) in questionData"
                    :key="index"
                    :data-index="index"
                >
                    <div style="margin-top: 50px; position: relative">
                        <CapsuleProgress
                            style="position: absolute; right: 50px"
                            :title="
                                item.optionType == '1'
                                    ? '单选'
                                    : item.optionType == '2'
                                    ? '多选'
                                    : ''
                            "
                            :currentId="currentId"
                            :totals="totals"
                        />
                        <span
                            v-for="(el, s) in item.childType"
                            :key="s"
                            :data-path="el.path"
                            class="progress"
                        >
                            <span class="progress-circle"
                                ><strong :class="{ isOver: parseInt(100) > 0 }"></strong
                            ></span>
                            <span class="progress-name" :class="{ isOver: parseInt(100) > 0 }">{{
                                el.name
                            }}</span>
                            <img
                                v-if="parseInt(100) > 0"
                                src="../../../static/images/dashed-color.png"
                                alt=""
                            />
                            <img v-else src="../../../static/images/dashed.png" alt="" />
                            <span
                                style="
                                    position: relative;
                                    top: -12px;
                                    width: 140px;
                                    display: inline-block;
                                "
                                ><a-progress
                                    strokeColor="#5867dd"
                                    :showInfo="showInfo"
                                    :percent="100"
                                    size="small"
                            /></span>
                        </span>
                    </div>
                    <div
                        v-show="showQuestion === index + '' + i"
                        v-for="(question, i) in item.childQuestion"
                        :key="question.questionId"
                        :class="{ questionList: true, 'disable-mark': isClick }"
                        data-index="i"
                    >
                        <div class="question-header">
                            <img
                                class="question-header-legalScope"
                                v-show="question.legalScope == '1'"
                                src="../../../static/images/xing.png"
                            />
                            <div
                                class="question-title"
                                @mouseover="showDescribe"
                                @mouseout="hideDescribe"
                                v-html="question.questionHead"
                            ></div>
                        </div>
                        <div v-if="question.optionType === '1'" class="question-option">
                            <!-- <a-radio-group :name="'a'+i+''" :defaultValue="getValue(question)" :style="'text-align:left;width:'+getWidth(question.optionList)+'px;margin:0 auto'"> -->
                            <div
                                class="ant-radio-group ant-radio-group-outline ant-radio-group-default"
                            >
                                <label
                                    @mouseover="showDescribe"
                                    @mouseout="hideDescribe"
                                    v-for="(opt, n) in question.optionList"
                                    :key="n"
                                    @click.prevent="
                                        clickAnswer(
                                            $event,
                                            'radio',
                                            index,
                                            i,
                                            n,
                                            opt,
                                            question,
                                            null
                                        )
                                    "
                                >
                                    <a-radio
                                        :defaultChecked="isChecked(+opt.checked)"
                                        :checked="!!+opt.checked"
                                        class="optionFlex"
                                        style="white-space: normal !important"
                                        ><strong
                                            style="font-weight: normal; font-size: 0.2rem"
                                            v-html="opt.description"
                                        ></strong
                                    ></a-radio>
                                </label>
                            </div>
                        </div>
                        <div v-else class="question-option">
                            <label
                                @mouseover="showDescribe"
                                @mouseout="hideDescribe"
                                class="question-check clearfix"
                                style="min-width: 6rem"
                                :data-info="opt.description.length"
                                v-for="(opt, n) in question.optionList"
                                :key="opt.optionId"
                            >
                                <a-checkbox
                                    class="optionFlex"
                                    :checked="isChecked(opt.checked)"
                                    @click="
                                        clickAnswer(
                                            $event,
                                            'checkbox',
                                            index,
                                            i,
                                            n,
                                            opt,
                                            question,
                                            opt.exclusive
                                        )
                                    "
                                    :value="opt.description"
                                    ><strong
                                        style="font-weight: normal; font-size: 0.2rem"
                                        v-html="opt.description"
                                    ></strong
                                ></a-checkbox>
                            </label>
                        </div>
                        <div class="question-btn">
                            <a-button
                                v-show="hasPrev"
                                @click="handlePrevClick(question.questionId)"
                                style="width: 1rem; height: 0.4rem"
                                >上一题</a-button
                            >
                            <a-button
                                :data-len="item.childQuestion.length"
                                type="primary"
                                style="width: 1rem; height: 0.4rem"
                                @click="_getNextQuestions(question)"
                                >{{ submitText }}</a-button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--名词解释弹出框 opt.checked-->
        <div class="describe" v-show="describeIsShow" :style="describeStyle">
            <div class="describe-title">注释<span></span></div>
            <div class="describe-content">{{ describe }}</div>
        </div>
    </div>
</template>

<script>
    import CapsuleProgress from '@/components/CapsuleProgress/CapsuleProgress'

    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'

    import { debounce, STATIC_IMG_MAP, ICON_FONT_IMG_MAP } from '@/utils/public'

    const QUESTION_ID_MAP = {
        previousQuestion: 'previousQuestionId',
        nextQuestion: 'questionId',
    }
    export default {
        name: 'Question',
        components: {
            CapsuleProgress,
        },
        beforeCreate() {
            let that = this
            // that.bus.$emit('loading', true);
            //请求名词解释
            let nounComment = ajax(apiListPC.getAll)
            nounComment.then(function (res) {
                that.nounCommentList = res.data

                res.data.forEach(function (item) {
                    that.keyWords.push({
                        nounName: item.nounName,
                        nounComment: item.nounComment,
                    })
                })

                that.getInitQuestion()
                that.getTopModule()
            })
        },
        data() {
            return {
                questionData: [],
                showLeftIndex: '0',
                showRightIndex: 0,
                showInfo: false,
                showQuestion: '00',
                percent: {},
                nounCommentList: [],
                keyWords: [],
                describe: '',
                describeIsShow: false,
                describeStyle: 'top:0;left:0;',
                submitDisabled: true,

                currentId: 1,
                totals: null,
                finalQuestionFlag: 0,
                submitText: '下一题',
                questionTab: [],
                isClick: false,
            }
        },
        computed: {
            hasPrev() {
                return this.currentId > 1
            },
        },
        watch: {
            submitText() {
                if (this.submitText == '提交问卷') {
                    this.showSurveyConfirm()
                }
            },
        },
        methods: {
            isChecked(_checked) {
                return _checked > 0
            },
            getTopModule() {
                ajax(`${apiListPC.getTopModule}/${sessionStorage.getItem('surveyId')}`).then(
                    (res) => {
                        // ajax(`${apiListPC.getTopModule}/350`).then(res => {
                        this.questionTab = res.data.map((item) => {
                            item.img = ICON_FONT_IMG_MAP[item.moduleId] || 'panda_mobilebumen-moren'
                            // item.img = STATIC_IMG_MAP[item.moduleId] || 'default';
                            return item
                        })
                    }
                )
            },
            //请求基本的题目
            getInitQuestion() {
                let that = this
                let sendData = {
                    // enterpriseId: sessionStorage.getItem('enterpriseId'),
                    moduleIds: sessionStorage.getItem('modules').split(','),
                    surveyId: sessionStorage.getItem('surveyId'),
                }

                // that.bus.$emit('loading', true);
                ajax(apiListPC.getInitQuestion, sendData, 'POST')
                    .then(function (data) {
                        let res = {
                            returnData: [],
                        }
                        res.returnData = [data.data]
                        initData(res, that, false)
                        that.totals = data.data.totalNumber
                    })
                    .catch(function () {
                        // that.bus.$emit('loading', false);
                    })
            },
            getWidth(optionList = []) {
                if (optionList) {
                    let arr = []
                    optionList.forEach(function (item) {
                        arr.push(item.description.length * 16 + 20)
                    })
                    return Math.max(...arr) <= 692 ? Math.max(...arr) : 692
                }
            },
            getValue(question) {
                let des = ''
                question.optionList.forEach(function (item) {
                    if (item.checked == true) {
                        des = item.description
                    }
                })
                return des
            },

            async _getNextQuestions(_question) {
                if (this.submitText == '提交问卷') {
                    this.showSurveyConfirm()
                    return false
                }
                const cur_optionlsId = _question.optionList
                    .map((i) => i.checked > 0 && i.optionId)
                    .filter((i) => i)
                if (cur_optionlsId.length < 1) {
                    this.$message.warning('请完成当前题目')
                    return
                }
                const paramsData = {
                    questionId: _question.questionId,
                    questionType: _question.questionType,
                    optionListId: cur_optionlsId || [], // 当前题所选项数组
                    moduleId: _question.moduleId,
                    jumpRuleId: _question.jumpRuleId,
                    sortNumber: _question.sortNumber,
                    moduleIds: sessionStorage.getItem('modules').split(','),
                    surveyId: sessionStorage.getItem('surveyId'),
                }

                // this.bus.$emit('loading', true);
                this.isClick = true
                const nextQuestion = await ajax(apiListPC.getNextQuestions, paramsData, 'POST')
                // 最后一题，判断是否返回数据
                this.finalQuestionFlag = !!nextQuestion.data ? 0 : 1
                // 接口失败，1秒后取消disable-mark
                setTimeout(() => {
                    this.isClick = false
                }, 1000)
                let that = this
                that._getAnswerProgress('nextQuestion', _question, cur_optionlsId)
                if (!!nextQuestion.data && nextQuestion.data.questionId) {
                    let res = {
                        returnData: [],
                    }
                    res.returnData = [nextQuestion.data]
                    initData(res, that, false)
                } else {
                    if (nextQuestion.returnCode != 200) {
                        this.$message.warning('获取下一题失败，请重试')
                        return false
                    }
                    this.submitText = '提交问卷'
                }
            },
            handlePrevClick: debounce(async function (questionId) {
                if (!questionId) {
                    this.$message.warning('获取上一题有误，请重试!')
                    return false
                }

                // this.bus.$emit('loading', true);
                const paramsData = {
                    questionId,
                    surveyId: sessionStorage.getItem('surveyId'),
                }
                this.isClick = true
                ajax(apiListPC.getPreviousQuestions, paramsData, 'POST')
                    .then((data) => {
                        // 最后一题，判断是否返回数据
                        this.finalQuestionFlag = !!data.data ? 0 : 1
                        let that = this
                        if (data.data && data.data.questionId) {
                            let res = {
                                returnData: [],
                            }
                            res.returnData = [data.data]
                            initData(res, that, false)
                            that._getAnswerProgress('previousQuestion', data.data)
                        } else {
                            that.submitText = '提交问卷'
                        }
                    })
                    .catch((err) => {
                        // 接口失败，1秒后取消disable-mark
                        setTimeout(() => {
                            this.isClick = false
                        }, 1000)
                    })
            }),
            clickAnswer: debounce(async function (
                el,
                type,
                outerIndex,
                innerIndex,
                optionIndex,
                item,
                question,
                exclusive
            ) {
                //更新当前题目答案的checked值
                if (type === 'radio') {
                    this.questionData[outerIndex].childQuestion.forEach(function (item) {
                        if (item.questionId == question.questionId) {
                            item.optionList.forEach(function (i) {
                                i.checked = false
                            })
                            // item.optionList[optionIndex].checked = el.target.checked;// el.target.checked 是undefined
                            item.optionList[optionIndex].checked = true
                        }
                    })
                } else {
                    this.questionData[outerIndex].childQuestion.forEach(function (item) {
                        if (item.questionId == question.questionId) {
                            item.optionList[optionIndex].checked = el.target.checked
                        }
                    })
                    //选项互斥逻辑
                    if (exclusive == '1' && el.target.checked) {
                        //如果该选项与其他选项互斥 那么将其他选项变成false
                        this.questionData[outerIndex].childQuestion.forEach(function (item) {
                            if (item.questionId == question.questionId) {
                                item.optionList.forEach(function (opt) {
                                    opt.checked =
                                        opt.optionId == item.optionList[optionIndex].optionId
                                })
                            }
                        })
                    }
                    if (exclusive == '0' && el.target.checked) {
                        //如果点击了其他选择 需要把互斥选项变成false
                        this.questionData[outerIndex].childQuestion.forEach(function (item) {
                            if (item.questionId == question.questionId) {
                                item.optionList.forEach(function (opt) {
                                    if (opt.exclusive == '1') {
                                        opt.checked = false
                                    }
                                })
                            }
                        })
                    }
                }

                let currentQuesNumber = 0
                this.questionData[outerIndex].childQuestion.forEach(function (item) {
                    if (item.questionId == question.questionId) {
                        item.optionList.forEach(function (i) {
                            if (i.checked) {
                                currentQuesNumber++
                            }
                        })
                    }
                })
                if (currentQuesNumber > 0) {
                    this.submitDisabled = false
                } else {
                    this.submitDisabled = true
                }
                //记录当前题目未选中的选项
                let uncheckedIds = []
                this.questionData[outerIndex].childQuestion.forEach(function (item) {
                    if (item.questionId == question.questionId) {
                        item.optionList.forEach(function (i) {
                            if (!i.checked) {
                                uncheckedIds = uncheckedIds.concat(i.optionId)
                            }
                        })
                    }
                })

                if (type == 'checkbox') return false
                setTimeout(() => {
                    let that = this

                    const paramsData = {
                        questionId: item.questionId,
                        questionType: question.questionType,
                        optionListId: item.optionId.split(','), // 当前题所选项数组
                        moduleId: question.moduleId,
                        jumpRuleId: question.jumpRuleId,
                        sortNumber: question.sortNumber,
                        moduleIds: sessionStorage.getItem('modules').split(','),
                        surveyId: sessionStorage.getItem('surveyId'),
                    }

                    // that.bus.$emit('loading', true);
                    that.isClick = true
                    ajax(apiListPC.getNextQuestions, paramsData, 'POST')
                        .then((data) => {
                            // 最后一题，判断是否返回数据
                            that.finalQuestionFlag = !!data.data ? 0 : 1
                            that._getAnswerProgress('nextQuestion', item, item.optionId.split(','))
                            if (!!data.data) {
                                let res = {
                                    returnData: [],
                                }
                                res.returnData = [data.data]
                                initData(res, that, false)
                            } else {
                                if (data.returnCode != 200) {
                                    that.$message.warning('获取下一题失败，请重试')
                                    return false
                                }
                                that.submitText = '提交问卷'
                            }
                        })
                        .catch((err) => {
                            // 接口失败，1秒后取消disable-mark
                            setTimeout(() => {
                                that.isClick = false
                            }, 1000)
                        })
                }, 300)
            }),

            _getAnswerProgress(type, resQuestion, _optionlsId) {
                const paramsData = {
                    [QUESTION_ID_MAP[type]]: resQuestion.questionId,
                    optionListId: _optionlsId,
                    moduleIds: sessionStorage.getItem('modules').split(','),
                    surveyId: sessionStorage.getItem('surveyId'),
                    totalNumber: this.totals,
                    finalQuestion: this.finalQuestionFlag || 0,
                }
                ajax(apiListPC.getAnswerProgress, paramsData, 'POST').then((res) => {
                    this.currentId = res.data.completedQuestionsNumber || 1
                    this.totals = res.data.totalNumber
                })
            },
            showSurveyConfirm() {
                let that = this
                that.$confirm({
                    title: '答题已完成，是否提交？',
                    okType: 'primary',
                    okText: '确定',
                    cancelText: '取消',
                    onOk() {
                        const paramsData = {
                            moduleIds: sessionStorage.getItem('modules').split(','),
                            surveyId: sessionStorage.getItem('surveyId'),
                        }
                        // that.bus.$emit('loading', false);
                        ajax(apiListPC.submitSurvey, paramsData, 'POST').then(() => {
                            that.$router.replace({
                                path: '/Report',
                                query: {
                                    surveyId: sessionStorage.getItem('surveyId'),
                                    enterpriseId: sessionStorage.getItem('enterpriseId'),
                                },
                            })
                        })
                    },
                    onCancel() {
                        that.submitText = '下一题'
                        // that.bus.$emit('loading', false);
                        that.isClick = false
                    },
                })
            },
            showDescribe(el) {
                if (el.target.nodeName == 'I') {
                    this.describe = el.target.dataset.info
                    this.describeStyle = `left:${el.pageX - 312}px;top:${el.pageY + 30}px`
                    this.describeIsShow = true
                } else {
                    this.describeIsShow = false
                }
            },
            hideDescribe() {
                this.describeIsShow = false
            },
        },
    }

    function initData(data, that, needChangeBoolean) {
        let alreadyKeysArr = []

        //把一个模块里面的标题和题放在顶级模块里面 方便循环显示
        data.returnData.forEach(function (item) {
            item.img = ICON_FONT_IMG_MAP[item.moduleId] || 'panda_mobilebumen-moren'
            let typeArr = []
            let questionArr = []

            that.showLeftIndex = item.firstLevelModuleId

            item.fullPath = `${item.questionId},${item.moduleId}`
            typeArr.push({
                name: item.moduleName,
                path: item.fullPath,
            })
            questionArr = [item]

            item.childType = typeArr
            item.childQuestion = questionArr
        })
        //把数据里面的'checked'改成true 组件里面需要的是boolean值
        if (needChangeBoolean) {
            console.log(needChangeBoolean, 'needChangeBoolean')
            data.returnData.forEach(function (item) {
                item.childQuestion.forEach(function (question) {
                    question.optionList.forEach(function (option) {
                        if (option.checked == '1') {
                            option.checked = true
                        } else {
                            option.checked = false
                        }
                    })
                })
            })
        }
        that.questionData = data.returnData

        getNounName(that, 0, 0, alreadyKeysArr)

        that.submitText = '下一题'
        // that.bus.$emit('loading', false);
        that.isClick = false
    }
    function getNounName(that, outerIndex, innerIndex, alreadyKeysArr) {
        for (let key of that.keyWords) {
            let regExp = new RegExp(key.nounName) //正则表达式方法，完全匹配对应的关键字，且声明全局
            // 不包含'data-info'证明是没有添加注释的，需要匹配添加注释
            if (
                !that.questionData[outerIndex].childQuestion[innerIndex].questionHead.includes(
                    'data-info'
                )
            ) {
                if (
                    that.questionData[outerIndex].childQuestion[innerIndex].questionHead.includes(
                        key.nounName
                    ) &&
                    !alreadyKeysArr.includes(key.nounCommentId)
                ) {
                    alreadyKeysArr.push(key.nounCommentId)
                    that.questionData[outerIndex].childQuestion[innerIndex].questionHead =
                        that.questionData[outerIndex].childQuestion[
                            innerIndex
                        ].questionHead.replace(
                            regExp,
                            `<i style="color:#5867dd;font-style:normal;" data-info="${key.nounComment}">${key.nounName}</i>`
                        )
                }
            }
            that.questionData[outerIndex].childQuestion[innerIndex].optionList.forEach(function (
                item
            ) {
                if (!item.description.includes('data-info')) {
                    if (
                        item.description.includes(key.nounName) &&
                        !alreadyKeysArr.includes(key.nounCommentId)
                    ) {
                        alreadyKeysArr.push(key.nounCommentId)

                        item.description = item.description.replace(
                            regExp,
                            `<i style="color:#5867dd;font-style:normal;" data-info="${key.nounComment}">${key.nounName}</i>`
                        )
                    }
                }
            })
        }
    }
</script>

<style lang="less" type="text/less" scoped>
    .global-content {
        margin: 0 auto;
        width: 80%;
        .question {
            /*position: absolute;
    top: 50px;
    bottom: 50px;
    left: 25px;
    right: 25px;*/
            width: 100%;
            padding-top: 20px;
            display: flex;
            justify-content: space-between;

            .question-left {
                // width: 180px;
                // height: 100%;
                // float: left;

                height: 100%;
                flex: 1;
                ul {
                    padding: 0;
                    margin: 0;

                    li {
                        list-style: none;
                        // width: 160px;
                        height: 50px;
                        line-height: 50px;
                        background: #f4f6f9;
                        text-align: left;
                        margin-left: 10px;
                        // cursor: pointer;
                        position: relative;
                        text-indent: 15px;
                        border-bottom: 1px solid #ddd;
                        // border-radius: 10px;
                        &:last-child {
                            border: none;
                        }
                        &.active {
                            background: #5867dd;
                            color: #fff;
                        }
                        span {
                            display: block;
                            position: absolute;
                            width: 10px;
                            height: 10px;
                            right: -5px;
                            top: 20px;
                            background: #5867dd;
                            transform: rotate(45deg);
                        }
                        img {
                            width: 26px;
                            margin-right: 7px;
                        }
                    }
                }
            }

            .disable-mark {
                opacity: 0.8;
                pointer-events: none;
            }

            .disable-mark {
                opacity: 0.8;
                pointer-events: none;
            }
            .question-right {
                // width: calc(100% - 200px);
                // height: 100%;
                // float: left;
                // border: 1px solid #ddd;
                height: 100%;
                border: 1px solid #ddd;
                width: 85%;
                margin-left: 20px;
                min-height: 780px;
                .right-box {
                    display: none;
                    width: 100%;
                    height: 100%;
                    padding: 0 20px 40px;

                    .progress {
                        height: 70px;
                        display: inline-block;
                        position: relative;
                        img {
                            position: absolute;
                            width: 104px;
                            height: 32px;
                            top: -18px;
                            left: 30px;
                        }
                        .progress-name {
                            position: absolute;
                            top: -8px;
                            left: 70px;
                            color: #333;
                            font-size: 0.2rem;
                            opacity: 0.5;
                            word-break: keep-all;
                            width: 100%;
                            text-align: left;
                            &.isOver {
                                color: #5867dd;
                                opacity: 1;
                            }
                        }
                        .progress-circle {
                            width: 40px;
                            height: 40px;
                            display: inline-block;
                            box-shadow: 0 0 5px #aaa;
                            border-radius: 50%;
                            strong {
                                text-align: justify;
                                align-items: flex-start;
                                width: 28px;
                                height: 28px;
                                display: inline-block;
                                float: left;
                                margin: 6px;
                                padding-left: 6px;
                                background: #ddd;
                                border-radius: 50%;
                                font-size: 14px;
                                color: #fff;
                                padding-top: 4px;
                                &.isOver {
                                    background: #5867dd;
                                }
                            }
                        }
                    }
                    .questionList {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .question-header {
                            display: flex;
                            .question-title {
                                margin-top: 0.4rem;
                                font-size: 0.3rem;
                                line-height: 0.4rem;
                                margin-bottom: 0.4rem;
                            }
                            .question-header-legalScope {
                                margin: 10px;
                                margin-top: 0.45rem;
                                width: 0.3rem;
                                height: 0.3rem;
                            }
                        }
                        .question-option {
                            width: 40%;
                            .optionFlex {
                                display: flex;
                                text-align: justify;
                                flex-direction: row;
                                justify-content: flex-start;
                                align-items: baseline;
                                padding: 5px 0;
                            }
                            .question-check {
                                // display: block;
                                position: relative;
                                cursor: pointer;
                                margin-bottom: 0.2rem;
                                /*.ant-checkbox{
                position:absolute;
                top:0;
                left:-22px;
              }*/
                                strong {
                                    text-align: justify;
                                    align-items: flex-start;
                                    //line-height:21px;
                                    font-size: 0.2rem;
                                }
                            }
                        }
                        .question-btn {
                            margin-top: 45px;
                            text-align: center;
                            button {
                                margin: 0 10px;
                            }
                        }
                    }
                    &.active {
                        display: block;
                    }
                }
            }
        }
        .describe {
            width: 624px;
            position: absolute;
            border: 1px solid rgba(226, 226, 226, 1);
            background: #fff;
            .describe-title {
                width: 100%;
                height: 38px;
                text-indent: 19px;
                font-size: 16px;
                color: #fff;
                line-height: 38px;
                text-align: left;
                background: #5867dd;
                position: relative;
                span {
                    position: absolute;
                    top: -5px;
                    left: 50%;
                    margin-left: -5px;
                    width: 10px;
                    height: 10px;
                    background: #5867dd;
                    transform: rotate(45deg);
                }
            }
            .describe-content {
                padding: 12px 19px 14px;
                opacity: 0.5;
                color: #333;
                font-size: 14px;
                text-align: left;
                background: #fff;
            }
        }
    }
    // ::v-deep .ant-checkbox {
    //   margin-top: 8px;
    // }
    // ::v-deep .ant-radio {
    //   margin-top: 8px;
    // }
</style>
<style>
    /*全局滚动条样式*/
    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }
</style>
